import React from 'react';
// import {
//   Info as Icon // TODO: select an icon
// } from 'components/icons';

import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="code" {...props} />;
}

export const meta = {
  title: 'Development',
  category: 'Engineering',
  exposes: [
    {
      title: 'General',
      action: { module: 'Sample', props: { context: 'Window' } },
      desription: 'general-desc',
    },
    {
      title: 'UI',
      action: { module: 'Sample', props: { context: 'UI' } },
      desription: 'ui-desc',
    },
    // {
    //   title: 'API',
    //   action: { module: 'Sample', props: { context: 'API' } },
    //   desription: 'api-desc',
    // },
    {
      title: 'Form',
      action: { module: 'Sample', props: { context: 'Form' } },
      desription: 'form-desc',
    },
    {
      title: 'FormFromFields',
      action: { module: 'Sample', props: { context: 'FormFromFields' } },
      desription: 'form-desc',
    },
    {
      title: 'Special',
      action: { module: 'Sample', props: { context: 'Special' } },
      desription: 'form-desc',
    },
    // {
    //   title: 'Demo',
    //   action: { module: 'Demos', props: { }},
    //   desription: 'demo',
    // }
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `A sample module that will try to use most features`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
